Apt.fn.make('properties.relevant', {
	/**
	 * Display relevant properties
	 *
	 * @param {Object} options
	 * @param {Object} [ad]
	 * @returns {Object}
	 */
	init(options, ad) {
		const scope = this;
		const conf = Object.assign({
			paginate: false,
			resource: 'listings/relevant',
			standalone: true
		}, options);
		const $target = $$('relevantProperties', conf.context);
		const app = 'relevant-' + LS.util.uid();

		let events;
		let ads;

		conf.params.paginate = false;

		scope.index = Apt.fn.index().init({
			app: app,
			view: 'properties.relevant',
			resource: conf.resource,
			target: $target,
			event: false,
			scrollTop: conf.paginate ?
				(() => $.screen.size() < 3) : false,
			paginate: conf.paginate,
			model: {
				ad: ad ?
					ad.position : null,
				loading: true,
				scroll: options.scroll,
				standalone: conf.standalone
			},
			flash: false,
			static: true,
			params: Object.assign({
				limit: 5
			}, conf.params),
			filters: Object.assign({
				near: $.context('location.center') || LS.user.center()
			}, conf.filters),
			transform: Apt.properties.transform,
			translate: filters => {
				if ((LS.user.get('hidden') || []).length) {
					filters.user = LS.user.get('id');
				}
			},
			updated: (data, init) => {
				const results = data.results;

				if (! init && events) {
					events.update();
				}

				Object.values(results).forEach(item => {
					LS.analytics.track({
						action: 'preview',
						target: 'listing',
						id: item.id,
						category: 'entry',
						segment: 'relevant'
					}, {
						key: item.context.key,
						source: item.context.source,
						send: false
					});
				});

				LS.analytics.send();

				$.exec(conf.updated, {
					args: [data]
				});

				if (ad) {
					if (ads) {
						ads.load();
					} else if (results.length) {
						LS.util.load('ads', () => {
							ads = Apt.fn.ads().init({
								margin: () => 800,
								target: ad.target,
								units: () => $('[data-unit]', $target)
							});
						});
					}
				}
			},
			unload: () => {
				if (events) {
					events.unload();
				}

				if (ads) {
					ads.unload();
				}

				$.exec(conf.unload);
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}

				if (ads) {
					ads.$destroy();

					ads = null;
				}
			}
		}, () => {
			events = Apt.fn['properties.events']()
				.init({
					app: app,
					createMap: conf.createMap,
					delegate: $target,
					map: conf.map
				});
		});

		return scope;
	},

	/**
	 * Update listing results
	 *
	 * @param {Object} [filters]
	 * @param {Object} [model]
	 */
	update(filters, model) {
		const index = this.index;

		index.filter(Object.assign({
			near: $.context('location.center')
		}, filters));

		if (model) {
			index.app.$merge(model);
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.destroy(this, 'index');
	}
});